function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.14 27.76",
    style: {
      enableBackground: "new 0 0 24.14 27.76"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "personalize",
    transform: "translate(1.4 1.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Telefon",
    style: {
      fill: "none",
      stroke: "#70A848",
      strokeWidth: 2.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M8.82,14.36 C8,13.2,7.28,11.96,6.68,10.67C6.3,9.87,6.47,9.71,7.31,9.21s1.1-0.64,1.28-0.75c1.24-0.72,1.25-0.74,0.49-2.34 c-0.45-0.96-1.66-3.53-2.1-4.43C6.66,1,5.86,0.7,5.17,1.01C5.08,1.05,5,1.1,4.93,1.16C3.95,1.83,3.1,2.68,2.44,3.67 C1.68,5.03,1.43,6.61,1.71,8.14c0.55,3.13,1.81,6.1,3.68,8.68c1.82,2.61,4.22,4.76,7,6.3c1.35,0.76,2.93,1.03,4.46,0.77 c1.16-0.29,2.24-0.81,3.19-1.54c0.62-0.45,0.76-1.33,0.3-1.95c-0.04-0.06-0.09-0.11-0.14-0.16c-0.57-0.59-2.73-2.68-3.51-3.42 c-1.28-1.24-1.28-1.24-2.38-0.3c-0.36,0.31-0.55,0.47-1.12,0.97c-0.74,0.64-0.95,0.71-1.58,0.12C10.58,16.6,9.65,15.52,8.82,14.36z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c1a1ae4ea6a7424766ddd74fe732bb8f.svg";
export { ForwardRef as ReactComponent };